import { Card, Typography, Grid, Box, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

export default function DataDirectorCollapse({ study }: any) {

	return <Card>
		<Grid container direction={'column'}>
			<Box m={2} bgcolor={'#F4F6F8'} borderRadius={2} height={50}>
				<Grid container direction={'row'} mt={1.5}>
					<Grid item xs={8} alignItems={'center'} spacing={2}>
						<Typography color={'#637381'} textAlign='center' mr={9}>
							<b>Informações de plano diretor</b>
						</Typography>
					</Grid>
					<Grid item xs={4} alignItems={'flex-start'}>
						<Typography color={'#637381'} textAlign='flex-start'>
							<b>Dado</b>
						</Typography>
					</Grid>
				</Grid>
			</Box>
			<Box m={2} mb={6}>
				<Grid container direction={'row'} ml={-1} spacing={4}>
					<Grid item xs={7}>
						<Typography>
							Plano diretor
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.legislation_info === true ? "Sim" : "Não")}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Testada lotes residenciais
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.resLot_front_size || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Área mínima lotes residenciais
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.resLot_min_area || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Profundidade lotes residenciais
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.resLot_lot_depth || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Testada lotes residenciais esquina
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.resCorner_front_size || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Profundidade lotes residenciais esquina
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.resCorner_lot_deptha || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Área mínima lotes residenciais esquina
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.resCorner_min_area || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Testada lotes comerciais
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.commercialLot_front_size || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Área mínima lotes comerciais
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.commercialLot_min_area || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Profundidade lotes comerciais
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.commercialLot_lot_depth || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Testada lotes comerciais esquina
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.commercialCorner_front_size || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Área mínima lotes comerciais esquina
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.commercialCorner_min_area || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Profundidade lotes comerciais esquina
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.commercialCorner_lot_depth || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Comprimento máximo de quadras
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.block_length || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							% das doações que podem ser feitas dentro de apps
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.donate_appAv || 0)}%
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							% das doações que podem ser feitas dentro de áreas verdes
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.donate_green_area || 0)}%
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							% das doações que podem ser feitas dentro de áreas institucionais
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.donate_institutional_area || 0)}%
						</Typography>
					</Grid>
					<Grid item xs={12} ml={-2} mt={-2} mb={-2}>
						<Accordion
							sx={{
								boxShadow: "none !important",
								backgroundColor: "#FFF",
								":before": { display: "none" },
							}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon sx={{ justifySelf: 'left' }} />}
								sx={{
									justifyContent: 'flex-start',
									'.MuiAccordionSummary-content': {
										flexGrow: 'inherit'
									}
								}}
							>
								<Typography>Outras doações</Typography>
							</AccordionSummary>
							<AccordionDetails sx={{ backgroundColor: "#fff" }}>
								{study?.dataHelper?.donate_other}
							</AccordionDetails>
						</Accordion>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Vias locais
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.local_range || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Vias locais Calçadas
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.local_sidewalk || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Vias coletoras
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.collector_range || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Vias coletoras Calçadas
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.collector_sidewalk || 0)}m
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Diâmetro Cul-de-sac
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.arterial_range || 0)}m
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</Grid>
	</Card>
}